import orderStrings from 'modules/order/strings';

export const addressLabelList = [
  {
    key: 'Home',
    name: orderStrings.addAddressForm.addressLabelList.addressLabelHomeText,
  },
  {
    key: 'Work',
    name: orderStrings.addAddressForm.addressLabelList.addressLabelWorkText,
  },
  {
    key: 'Hotel',
    name: orderStrings.addAddressForm.addressLabelList.addressLabelHotelText,
  },
  {
    key: 'Other',
    name: orderStrings.addAddressForm.addressLabelList.addressLabelOtherText,
  },
];
